import { Accordion, AccordionDetails, AccordionSummary, LinearProgress } from "@mui/material";
import { Arrowdown2, Arrowleft, Import } from "../../../assets";
import {  InfoCard, Layout, TableRowResponsive , Button } from "../../components";
import { OffersDetailsController } from "../../controllers";
import { Helmet } from "react-helmet-async";
import moment from "moment-jalaali";
import { numberWithCommas, planTypeList } from "../../../core/utils";
import { Link } from "react-router-dom";
class OffersDetails extends OffersDetailsController {
  componentDidMount() {
    window.scrollTo(0, 0);
    this.getDetails();
  }
  render() {
    const { offerDetails , base64Loading ,loading, pdf_type} = this.state;
    return (
      <Layout title={`پیشنهاد بیمه نامه  / ${planTypeList.filter((p: { value: string; }) => p.value === offerDetails?.plan_type)[0]?.title} `}>
        <Helmet>
          <title> {` پیشنهاد بیمه نامه  / ${planTypeList.filter((p: { value: string; }) => p.value === offerDetails?.plan_type)[0]?.title} | بیمه زندگی هامرز`}</title>
        </Helmet>
        {loading ?
          <LinearProgress />
          :
          <>
 <div className="policy table-responsive scrollbar offer-details">
         <div className="offer-details-headline">
            <div className="d-flex">
            <Button loading={pdf_type === "UNIVERSAL_PRINT" && base64Loading} myStyle="bg-blue print-btn loading-spinner-primary" icon={Import} title="چاپ تعهدات" onClick={() => this.downloadPdf("UNIVERSAL_PRINT")} />
            <Button loading={pdf_type === "UNIVERSAL_OFFER_PRINT" && base64Loading} myStyle="bg-blue print-btn loading-spinner-primary" icon={Import} title="چاپ پیشنهاد" onClick={() => this.downloadPdf("UNIVERSAL_OFFER_PRINT")} />
            </div>
          <Link to="/insurance-universal-offers" className="back-btn">
          <span className="text ms-2">بازگشت</span>
                <Arrowleft />
            </Link>
         </div>
          
          <div className=" table-container hide-mobile">
            <table className="table ">
              <thead>
                <tr>
                  <th scope="col">ردیف</th>
                  <th scope="col">نام و نام خانوادگی بیمه گذار</th>
                  <th scope="col">تاریخ شروع</th>
                  <th scope="col">تاریخ پایان</th>
                  <th scope="col">نام و نام خانوادگی بیمه شده</th>
                  <th scope="col"> مدت دوره </th>
                  <th scope="col"> مدت پرداخت </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>1</th>
                  <td>{`${offerDetails?.policy_holder_first_name || ""} ${offerDetails?.policy_holder_last_name || ""}`}</td>
                  <td>{moment(`${offerDetails?.start_date}`, 'YYYY-M-D').format('jYYYY/jM/jD')}</td>
                  <td>{moment(`${offerDetails?.end_date}`, 'YYYY-M-D').format('jYYYY/jM/jD')}</td>
                  <td>{`${offerDetails?.isured_first_name} ${offerDetails?.isured_last_name}`}</td>
                  <td>{offerDetails?.duration}</td>
                  <td>{offerDetails?.payment_duration}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <Accordion className="policy-accordion hide-desktop">
            <AccordionSummary
              expandIcon={<img src={Arrowdown2} alt="هامرز" />}
              aria-controls="panel1a-content"
              className="summsry"
              id="panel1a-header"
            >
              <TableRowResponsive title="ردیف" value="1" />
              <TableRowResponsive title="نام و نام خانوادگی بیمه گذار" value={`${offerDetails?.policy_holder_first_name} ${offerDetails?.policy_holder_last_name}`} />
              <TableRowResponsive title="تاریخ شروع" value={moment(`${offerDetails?.start_date}`, 'YYYY-M-D').format('jYYYY/jM/jD')} />
            </AccordionSummary>
            <AccordionDetails
              className="d-flex flex-wrap"
            >
              <TableRowResponsive title="تاریخ پایان" value={moment(`${offerDetails?.end_date}`, 'YYYY-M-D').format('jYYYY/jM/jD')} />
              <TableRowResponsive title="نام و نام خانوادگی بیمه شده" value={`${offerDetails?.isured_first_name} ${offerDetails?.isured_last_name}`} />
              <TableRowResponsive title="مدت دوره " value={offerDetails?.duration} />

            </AccordionDetails>
            <AccordionDetails
              className="d-flex flex-wrap"
            >

              <TableRowResponsive title="مدت پرداخت " value={offerDetails?.payment_duration} />
            </AccordionDetails>
            {/* <AccordionDetails
              className="d-flex flex-wrap"
            >
              <div className="d-flex align-items-center" >
                <Button myStyle="bg-blue table-btn" title="جزئیات بیشتر" onClick={() => { }} />
                <span aria-describedby={this.id} onClick={this.handleClick} className="more">
                  <img src={More} alt="هامرز" />
                </span>
              </div>
            </AccordionDetails> */}


          </Accordion>


          <div className="offer-details-conetnt-row">
            <div className="inquery-section-title d-flex align-items-baseline text-end w-100 ms-0 mt-3">
              <hr className="hr-line" />

              اطلاعات بیمه نامه
              <hr className="hr-line" />
            </div>
            <InfoCard myStyle="w-30" lable="سرمایه فوت به هر علت (سال اول )" value={numberWithCommas(offerDetails?.start_death_asset)} text="ریال" />

            <InfoCard myStyle="w-30" lable="ضریب تعدیل سرمایه فوت" value={offerDetails?.adjustment_coefficient_death_benefit} text="درصد  " />
            {offerDetails?.plan_type === "UniversalHousing" ? <>
              <InfoCard myStyle="w-30" lable="حق بیمه " value={numberWithCommas(offerDetails?.pre_annually)} text="ریال" />

            </>:<>
              <InfoCard myStyle="w-30" lable="آورده اولیه" value={numberWithCommas(offerDetails?.saveing)} text="ریال" />
              </>
            }
            
        {offerDetails?.plan_type !== "UniversalHousing" && <>
            <div className="inquery-section-title d-flex align-items-baseline text-end w-100 ms-0 mt-3">
              <hr className="hr-line" />
              پوشش های انتخابی بیمه گذار
              <hr className="hr-line" />
            </div>
            <InfoCard myStyle="w-30" text="برابر" value={offerDetails?.accident_death_coverage} lable="پوشش فوت حادثه" />

            <InfoCard myStyle="w-30" text="درصد  " value={offerDetails?.cancer_coverage} lable="پوشش سرطان" />
            {/* <InfoCard myStyle="w-30" text="ریال" value={numberWithCommasofferDetails?.supplementary_special_diseases_coverage} lable="امراض خاص تکمیلی" /> */}



            <InfoCard myStyle="w-30" text="درصد" value={offerDetails?.accident_medical_cost_coverage} lable="هزینه پزشکی" />

            <InfoCard myStyle="w-30" text="درصد" value={offerDetails?.temporary_and_permanent_disability_coverage} lable="نقص عضو دائم کلی و جزئی" />
            <InfoCard myStyle="w-30" text="" value={offerDetails?.has_cancer_diagnosis ? "بله" : "خیر"} lable="هزینه تشخیص سرطان" />



            <InfoCard myStyle="w-30" text="" value={offerDetails?.has_temporary_disability_coverage ? "بله" : "خیر"} lable="پوشش غرامت روزانه عمومی" />
            <InfoCard myStyle="w-30" text="" value={offerDetails?.has_hos_benefit_coverage ? "بله" : "خیر"} lable="پوشش غرامت بستری" />
            <InfoCard myStyle="w-30" text="درصد" value={offerDetails?.main_special_diseases_coverage} unit={offerDetails?.has_supplementary_special_diseases_coverage ? "بله" : "خیر"} lable="امراض خاص اصلی / تکمیلی" />


            <InfoCard myStyle="w-30" text="درصد" value={offerDetails?.annuity_disability_coverage_disease} unit={offerDetails?.annuity_disability_coverage_accident} lable=" پرداخت مستمری از کارافتادگی دائم حادثه / بیماری " />
            <InfoCard myStyle="w-30" text="" value={offerDetails?.policy_holder_extra_dangers} lable=" خطرات اضافه بیمه گذار " /> 
            </>}
            {/* <InfoCard myStyle="w-48" text="درصد" value={offerDetails?.annuity_disability_coverage_accident} lable="پرداخت مستمری از کارافتادگی دائم ناشی از حادثه"/> */}
            {
              offerDetails?.plan_type === "UniversalFound" &&

              <>
                <div className="inquery-section-title d-flex align-items-baseline text-end w-100 ms-0 mt-3">
                  <hr className="hr-line" />
                  صندوق های انتخابی
                  <hr className="hr-line" />
                </div>
                {offerDetails && offerDetails?.universalproject?.length > 0 && offerDetails?.universalproject?.map((item: any, index: number) => (
                  <InfoCard myStyle="w-30" text="درصد" value={item?.percent} lable={item?.title} />
                ))
                }
  

              </>
            }

          </div>
        </div>
          </>
          }
       

      </Layout>
    )
  }
}
export default OffersDetails;